import { logger, LOGS } from "../../utils";
import { FeatureFlag } from "./types/user";

export class FeatureFlags {
    private activeFeatureFlags: FeatureFlag[] = [];

    public isEnabled(featureFlag: FeatureFlag): boolean {
        const includeFeature = this.activeFeatureFlags.includes(featureFlag);
        logger.info(
            LOGS.UserManager,
            `Feature flag ${featureFlag} is enabled : ${includeFeature}`,
        );

        return includeFeature;
    }

    /**
     * Helper method to add or remove a feature flag based on condition
     * @param flag - The feature flag to manage
     * @param isEnabled - Whether the flag should be enabled
     */
    public set(flag: FeatureFlag, isEnabled: boolean): void {
        if (isEnabled) {
            if (!this.activeFeatureFlags.includes(flag)) {
                this.activeFeatureFlags.push(flag);
            }
        } else {
            this.remove(flag);
        }
        logger.info(LOGS.UserManager, `${flag} = ${isEnabled}`);
    }

    public reset(): void {
        this.activeFeatureFlags = [];
    }

    public remove(flag: FeatureFlag): void {
        const index = this.activeFeatureFlags.indexOf(flag);
        if (index > -1) {
            this.activeFeatureFlags.splice(index, 1);
        }
    }
}
